import React from 'react';
import { FIRMA } from '../data/firma';
import styles from '../css/modules/MobileContactBar.module.css';

/**
 * Staly pasek kontaktu na telefonach (spec sekcja 28).
 * `spacer` rezerwuje wysokosc na koncu strony, zeby pasek nie zaslanial
 * stopki ani banera zgody.
 */
export default function MobileContactBar() {
  return (
    <>
      <div className={styles.spacer} aria-hidden="true" />
      <nav className={styles.bar} aria-label="Szybki kontakt">
        <a href={`tel:${FIRMA.telefonE164}`}>Zadzwoń</a>
        <a href={`mailto:${FIRMA.email}`}>Napisz</a>
        <a
          href="/diagnoza-sensoryczna-olsztyn/"
          className={styles.primary}
          data-cta="booking"
          data-cta-location="mobile-bar"
        >
          Umów diagnozę
        </a>
      </nav>
    </>
  );
}
